import { Button as ButtonComponent, ButtonProps } from '@/ui';

import { BlockBase, Wrapper } from '../utils';
import { transformButtonData } from './transform-button-data';

export interface ButtonBlockProps extends BlockBase {
  text?: string;
  href?: string;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
}

export function Button({ params, text, href, id, ...props }: ButtonBlockProps) {
  if (!text || !href) return null;

  const buttonProps = transformButtonData({ params, href, text, ...props });

  return (
    <Wrapper id={id}>
      <ButtonComponent {...buttonProps}>{text}</ButtonComponent>
    </Wrapper>
  );
}
